import { useSelector } from "react-redux";
import { RootState } from "../store/reducers/types/root";
import { DefinedUseQueryResult, useQuery } from "@tanstack/react-query";
import { ApiPaths, ProjectApiPaths } from "../services/paths";
import React from "react";
import { ListEventsRequest, ListEventsResponse } from "../services/types";
import { AxiosResponse } from "axios";
import { apiListEvents } from "../services/project";

interface UseEventsListProps {
  enabled?: boolean;
  defaultBody: ListEventsRequest;
}

export function useEventsList({
  enabled = true,
  defaultBody,
}: UseEventsListProps): [
  DefinedUseQueryResult<AxiosResponse<ListEventsResponse, any> | null, Error>,
  React.Dispatch<React.SetStateAction<ListEventsRequest>>
] {
  const token = useSelector((state: RootState) => state.user.token);
  const [body, setBody] = React.useState<ListEventsRequest>(defaultBody);
  const data = useQuery({
    queryKey: [ApiPaths.PROJECT, ProjectApiPaths.LIST_EVENTS, token, body],
    enabled: false,
    initialData: null,
    queryFn: () => apiListEvents(token as string, body),
  });

  React.useEffect(() => {
    if (enabled && token) {
      data.refetch();
    }
  }, [token, body]);

  return [data, setBody];
}
